<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
      </el-input>

    </template>
    <template slot="right">
      <el-button @click="$router.push({ name: 'createProductInfo' })" style="margin-right: 20px;">新增</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">
      <el-table :data="tableData" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="圖片" width="50px">
            <template slot-scope="scope">
              <img
                :src="scope.row.Tw.CoverImageURLX1"
                class="w-100"/>
            </template>
          </el-table-column>
        <el-table-column label="標題">
          <template slot-scope="scope">
            {{scope.row.Tw.Title}}
          </template>
        </el-table-column>

        <el-table-column label="狀態" width="70px">
          <template slot-scope="scope">
            <p v-if="scope.row.Tw.IsActive" class="deployed">發佈</p>
            <p v-else class="draft">下架</p>
          </template>
        </el-table-column>
        <!-- <el-table-column label="最後更新時間" width="170px">
          <template slot-scope="scope">
            {{scope.row.UpdatedAt | moment}}
          </template>
        </el-table-column> -->
        <el-table-column label="操作" :width="'120px'">
          <template slot-scope="scope">
            <el-button
              size="mini"
              round
              @click="$router.push({ name: 'updateProductInfo', params: { id: scope.row.ID }, query: { frompage: currentPage }})">編輯</el-button>

            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="20"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

      <productInfo-editor-modal :isShow="isShowAddeditModal" @close="isShowAddeditModal = false" @submitted="onObjAddedited" :ori-obj="editingObj"/>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import ProductInfoEditorModal from '@/data/productInfo/view/editor-modal.vue'
import Config from '@/assets/js/config.js'
// svgs
import '@/assets/svgs/index.js'

// mixin
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinLanguages, MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader,
    ProductInfoEditorModal
  },
  data () {
    return {
      config: Config,
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null,
      // modal
      isShowAddeditModal: false,
      editingObj: null
    }
  },
  computed: {
    dataList () {
      return this.$store.state.productInfo.list.filter(o => o.IsActive)
    }
  },
  methods: {
    isActiveIng (obj) {
      var now = moment(new Date())
      var started = true
      if (obj.BeginAt != null) started = now.isAfter(obj.BeginAt)
      if (!started) return false

      var finished = false
      if (obj.EndAt != null) finished = now.isAfter(obj.EndAt)
      if (finished) return false

      return true
    },
    onObjAddedited () {
      this.searchWithoutAlertResult()
    },
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    setFilterStatus (value) {
      this.filteringStatus = value
      this.filterObjs()
      this.tableData = this.searchedObjs.slice(0, 20)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.dataList
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        if (o.Tw && o.Tw.Title && o.Tw.Title.includes(this.keyword)) return true
        if (o.Cn && o.Cn.Title && o.Cn.Title.includes(this.keyword)) return true
        if (o.En && o.En.Title && o.En.Title.includes(this.keyword)) return true
        if (o.Jp && o.Jp.Title && o.Jp.Title.includes(this.keyword)) return true
        return false
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsActive === (this.filteringStatus === '已發佈')
      }

      this.searchedObjs = this.dataList.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 「${obj.Tw.Title}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.productInfo.inActivate(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.productInfo.list.findIndex(
            o => o.ID === obj.ID
          )
          if (idx >= 0) this.$set(this.$store.state.productInfo.list[idx], 'IsActive', false)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 20,
            this.currentPage * 20
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    }
  },
  created () {
    this.currentPage = parseInt(this.$route.query.page) || 1
    const initTableData = () => {
      this.searchedObjs = this.dataList
      this.tableData = this.searchedObjs.slice(0, 20)
    }

    if (
      !this.$store.state.productInfo.isFetched &&
      !this.$store.state.productInfo.isFetching
    ) {
      this.$services.fetchProductInfoDatas(this).then(initTableData).catch(this.$handleServiceError)
    } else {
      initTableData()
    }
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
.waiting {
  color: rgb(0, 149, 175);
  font-weight: 700;
}
.closed {
  color: #2a2a2a;
}
</style>
